import { useLayoutEffect } from "react";

/** Start the quote at its heading, not the welcome page's retained scroll offset. */
export function useQuoteEntryScroll() {
  useLayoutEffect(() => {
    // The signed-in shell scrolls <main>, not the browser window.
    const main = document.querySelector("main");
    main?.scrollTo({ top: 0, left: 0, behavior: "instant" });
    // Standalone/guest layouts use the document instead.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);
}
